import { Suspense, useContext, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { routes } from "./Routes";
import PrivateRoute from "./PrivateRoute";
import { ThemeContext } from "../common/themeContext";
import { CommonMessageProvider } from "../common/CommonMessage";
import Sidebar from "../components/Sidebar/Sidebar";

const AppRoutes = () => {
  const { theme } = useContext(ThemeContext);

  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token");
  const isChildRoute = routes.some(
    (route) => route.isChild && route.path === location.pathname
  );
  const hasChildAccess = Boolean(location.state?.fromChildRoute);

  useEffect(() => {
    const isOnRoot = location.pathname === "/login" || location.pathname === "/";
    const isOnPrivatePath = routes.some(
      (route) => route.isPrivate && route.path === location.pathname
    );

    if (token && isOnRoot) {
      navigate("/dashboard");
    } else if (!token && isOnPrivatePath) {
      navigate("/");
    } else if (token && isChildRoute && !hasChildAccess) {
      navigate("/ai-campaigns/manage-material");
    }
  }, [token, location.pathname, navigate, isChildRoute, hasChildAccess]);


  return (
    <div className={theme === "healthCare" ? "healthcare" : "primecare"}>
      <CommonMessageProvider>
        <Suspense>
          <Routes>
            {routes.map((route, index) => (
              <Route
                path={route?.path}
                key={"route_" + index}
                element={
                  route.isChild && !hasChildAccess ? (
                    <Navigate to="/ai-campaigns/manage-material" replace />
                  ) : route.isPrivate ? (
                    <>
                      <Sidebar>
                        <PrivateRoute redirectPath="/">
                          <route.element />
                        </PrivateRoute>
                      </Sidebar>
                    </>
                  ) : route?.isLayout ? (
                    <Sidebar>
                      <route.element />
                    </Sidebar>
                  ) : (
                    <route.element />
                  )
                }
              />
            ))}
          </Routes>
        </Suspense>
      </CommonMessageProvider>
    </div>
  );
};

export default AppRoutes;
